const brandFn = (root, storybookRoot) => {
  const brandImg = root.querySelector(".mdn-Brand-image");
  if (!brandImg) return;
  const brandImgSrc = brandImg.src;
  const rootClassName = root.className;

  const getSize = () => {
    if (rootClassName.match("mdn-Brand--lg")) {
      return "lg";
    } else if (rootClassName.match("mdn-Brand--md")) {
      return "md";
    } else {
      return "sm";
    }
  }

  const size = getSize();

  // Change image width if img is old format (old channels inside brand)
  const imgStyleWidthDictionary = {
    lg: {
      width: `74px`,
      height: `74px`
    },
    md: {
      width: `50px`,
      height: `50px`
    },
    sm: {
      width: `33px`,
      height: `33px`
    }
  };

  //Check if asset have "border" (old channels inside brands, brands>app and brands>flags)
  if (brandImgSrc.match(/https:\/\/mondrian\.claro\.com\.br\/brands\/(channels|app|flags)/)) {
    root.style.padding = 0;
    brandImg.style.maxWidth = `unset`;
    brandImg.style.maxHeight = `unset`;
    brandImg.style.position = `absolute`;
    brandImg.style.width = imgStyleWidthDictionary[size].width;
    brandImg.style.height = imgStyleWidthDictionary[size].height;
  }

  // Set backgroundColor if image needs a fallback (to avoid squares inside circle, for example...)
  const colorDictionary = {
    "https://mondrian.claro.com.br/channels/default/arte1.svg": "#a01a21"
  };

  if (colorDictionary[brandImg.src]) {
    root.style.backgroundColor = colorDictionary[brandImg.src] || "";
  }

  return storybookRoot ? storybookRoot : root;
};

export default brandFn;
